"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BellOff03 = function BellOff03(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15 19c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3M7.3775 7.8848C6.4909 8.8133 6 9.9847 6 11.2c0 2.2818-.5659 3.9506-1.272 5.1447-.8047 1.3609-1.207 2.0414-1.1911 2.2039.0181.186.0516.2447.2024.355C3.8712 19 4.5335 19 5.8582 19H19.88M12 6c-.2929 0-.5836.0186-.87.055-.3815.0484-.5723.0726-.7638.0206-.1378-.0375-.3456-.1583-.4464-.2596-.14-.1406-.1706-.2148-.2318-.3631A2.49 2.49 0 0 1 9.5 4.5C9.5 3.1193 10.6193 2 12 2s2.5 1.1193 2.5 2.5a2.492 2.492 0 0 1-.7035 1.7386A6.85 6.85 0 0 0 12 6m0 0c1.5913 0 3.1174.5479 4.2426 1.523C17.3679 8.4982 18 9.821 18 11.2c0 .3348.0091.6563.0264.9652M21 20 3 4"
    })
  }));
};
var _default = exports["default"] = BellOff03;